export const tvShows = [
  {
    id: "tv-001",
    title: "繁华落尽",
    type: "tv" as const,
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    duration: "全38集",
    director: "程若安",
    cast: ["姜知微", "沈砚之", "许静璇", "罗一鸣"],
    tags: ["商战", "群像", "女性成长"],
    synopsis:
      "三姐妹在家族企业崩塌后各自走向不同的人生。十年沉浮，她们在名利与亲情之间反复拉扯，最终明白繁华散尽后什么才最值得守护。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20series%20poster%2C%20elegant%20woman%20in%20a%20modern%20city%20penthouse%20at%20night%20with%20glowing%20skyline%20behind%2C%20sophisticated%20mood%2C%20warm%20and%20slate%20tones%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-001-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20glossy%20modern%20metropolis%20skyline%20at%20dusk%20seen%20from%20a%20high%20glass%20tower%2C%20warm%20city%20lights%2C%20sophisticated%20drama%20mood%2C%20no%20text&width=1600&height=900&seq=jg-tv-001-b&orientation=landscape",
    heat: 97,
  },
  {
    id: "tv-002",
    title: "长安十二楼",
    type: "tv" as const,
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2023,
    rating: 9,
    duration: "全45集",
    director: "陆文昭",
    cast: ["萧景行", "温以宁", "裴砚", "宋知溦"],
    tags: ["权谋", "国风", "高分"],
    synopsis:
      "盛唐长安，一夜之间十二座高楼的灯次第熄灭。年轻少卿与神秘女子联手追查，卷入一场横跨朝野的巨大阴谋，也在迷雾中窥见自己的身世之谜。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20costume%20drama%20poster%2C%20ancient%20Chinese%20city%20towers%20under%20a%20dramatic%20moonlit%20sky%2C%20ornate%20architecture%2C%20elegant%20historical%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-002-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20grand%20ancient%20Chinese%20palace%20city%20at%20night%20with%20glowing%20lanterns%20and%20mist%2C%20elegant%20historical%20epic%20scale%2C%20no%20text&width=1600&height=900&seq=jg-tv-002-b&orientation=landscape",
    heat: 99,
  },
  {
    id: "tv-003",
    title: "城市之光",
    type: "tv" as const,
    genres: ["都市", "爱情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    duration: "全32集",
    director: "许清和",
    cast: ["林可儿", "周衍", "苏禾"],
    tags: ["青春", "治愈", "都市"],
    synopsis:
      "两个在都市里努力生活的年轻人，在一场停电的夜里相遇。他们用各自的微光，照亮彼此最灰暗的日子，也重新定义了幸福的模样。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20series%20poster%2C%20two%20young%20people%20on%20a%20city%20rooftop%20at%20blue%20hour%20with%20warm%20city%20lights%2C%20tender%20modern%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-003-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20modern%20city%20street%20at%20blue%20hour%20with%20warm%20shop%20lights%20and%20a%20couple%20walking%2C%20romantic%20urban%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jg-tv-003-b&orientation=landscape",
    heat: 85,
  },
  {
    id: "tv-004",
    title: "迷雾航线",
    type: "tv" as const,
    genres: ["悬疑"],
    region: "美国",
    year: 2024,
    rating: 8.5,
    duration: "全10集",
    director: "Grace Whitmore",
    cast: ["Owen Frost", "Maria Cruz", "Leo Vance"],
    tags: ["罪案", "迷你剧", "冷峻"],
    synopsis:
      "一艘满载秘密的货轮驶入浓雾，船上九名船员接连失踪。随船调查员必须在航线结束前找出真凶，而真相比他想象的更加冰冷。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20series%20poster%2C%20ship%20emerging%20from%20thick%20sea%20fog%20at%20dawn%2C%20cold%20desaturated%20tones%2C%20tense%20suspenseful%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-004-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20cargo%20ship%20in%20dense%20sea%20fog%20with%20faint%20lighthouse%20glow%2C%20cold%20moody%20atmosphere%2C%20tense%20mystery%20mood%2C%20no%20text&width=1600&height=900&seq=jg-tv-004-b&orientation=landscape",
    heat: 90,
  },
  {
    id: "tv-005",
    title: "归途列车",
    type: "tv" as const,
    genres: ["家庭", "剧情"],
    region: "韩国",
    year: 2023,
    rating: 8.3,
    duration: "全16集",
    director: "郑敏贞",
    cast: ["尹在熙", "朴成植", "韩秀雅"],
    tags: ["亲情", "慢热", "催泪"],
    synopsis:
      "一位固执的老父亲决定独自坐火车去看望远嫁的女儿。一路上与陌生人的相遇，让他慢慢想起那些被自己忽略的、关于家人的温柔细节。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%2C%20elderly%20father%20and%20adult%20child%20on%20a%20moving%20train%20looking%20out%20the%20window%2C%20warm%20nostalgic%20light%2C%20emotional%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-005-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20rural%20train%20crossing%20green%20fields%20at%20golden%20hour%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20nostalgic%20mood%2C%20no%20text&width=1600&height=900&seq=jg-tv-005-b&orientation=landscape",
    heat: 76,
  },
  {
    id: "tv-006",
    title: "星火燎原",
    type: "tv" as const,
    genres: ["历史"],
    region: "中国大陆",
    year: 2022,
    rating: 8.9,
    duration: "全40集",
    director: "江怀远",
    cast: ["贺云舟", "陈子墨", "田振国"],
    tags: ["主旋律", "史诗", "热血"],
    synopsis:
      "一群风华正茂的年轻人，在最艰难的岁月里用信念点燃星火。他们的选择与牺牲，汇成一段波澜壮阔的时代记忆。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20historical%20war%20poster%2C%20soldiers%20marching%20across%20a%20vast%20plain%20under%20a%20burning%20orange%20sky%2C%20heroic%20epic%20mood%2C%20dramatic%20scale%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-006-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20vast%20battlefield%20plain%20at%20dawn%20with%20marching%20figures%20and%20rising%20smoke%2C%20heroic%20orange%20and%20gray%20tones%2C%20epic%20scale%2C%20no%20text&width=1600&height=900&seq=jg-tv-006-b&orientation=landscape",
    heat: 82,
  },
  {
    id: "tv-007",
    title: "邻家侦探社",
    type: "tv" as const,
    genres: ["喜剧", "悬疑"],
    region: "日本",
    year: 2024,
    rating: 7.9,
    duration: "全12集",
    director: "中村翔",
    cast: ["高桥悠", "伊藤凛", "山本健"],
    tags: ["轻推理", "下饭", "轻松"],
    synopsis:
      "一间开在居民楼里的小侦探社，专接鸡毛蒜皮的怪案。社长和她的猫助手，总能用最离谱的方式，解开最意想不到的谜题。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20mystery%20comedy%20poster%2C%20quirky%20small%20detective%20office%20with%20books%2C%20lamps%20and%20a%20curious%20cat%2C%20warm%20cozy%20colors%2C%20lighthearted%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-007-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20cozy%20cluttered%20neighborhood%20detective%20office%20interior%20with%20warm%20lamps%20and%20a%20cat%2C%20lighthearted%20playful%20mood%2C%20no%20text&width=1600&height=900&seq=jg-tv-007-b&orientation=landscape",
    heat: 74,
  },
  {
    id: "tv-008",
    title: "明日方程式",
    type: "tv" as const,
    genres: ["科幻", "剧情"],
    region: "美国",
    year: 2023,
    rating: 8.2,
    duration: "全20集",
    director: "Alan Pierce",
    cast: ["Ryan Holt", "Ivy Chen", "Samuel Boateng"],
    tags: ["未来", "伦理", "烧脑"],
    synopsis:
      "一项能预测未来的算法问世，却让整个世界陷入混乱。发明者必须在被自己的造物吞噬之前，找到那个可以改写明天的方程式。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20drama%20poster%2C%20scientist%20before%20a%20glowing%20holographic%20equation%20in%20a%20dark%20lab%2C%20cool%20blue%20and%20warm%20highlights%2C%20thoughtful%20futuristic%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-tv-008-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20futuristic%20laboratory%20with%20glowing%20holographic%20interfaces%20and%20a%20silhouetted%20scientist%2C%20cool%20blue%20glow%2C%20thoughtful%20mood%2C%20no%20text&width=1600&height=900&seq=jg-tv-008-b&orientation=landscape",
    heat: 78,
  },
];